import { useClientTranslations } from "../../lib/i18n/client";
import type { JourneyStep } from "../../types/journey";
import styles from "./StepDetail.module.css";

interface StepDetailProps {
	step: JourneyStep | null;
}

export function StepDetail({ step }: StepDetailProps) {
	const { t } = useClientTranslations("journey");

	if (!step) return null;

	return (
		<section className={styles.container} data-step-content="step-detail">
			<p className={styles.estimated}>
				{t("stepDetail.estimated", { range: step.estimatedDateRange })}
			</p>
			<p className={styles.description}>{step.description}</p>
		</section>
	);
}
